<template>
  <div class="vue-admin-wrap">
    <div>
      <b-modal
      hide-footer
      @hide="cancel"
      id="admin-modal"
      :modal-class="myclass">
        <template v-slot:modal-header>
          <span class="close-x" v-on:click="cancel()">×</span>
          <h3>Admin dashboard</h3>
        </template>
        <div class="modal-body-container">
          <div class="modal-body">
            <div class="menu">
              <ul class="menu-items">
                <li
                class="menu-item"
                v-on:click="showUtilityAdminWorkflow"
                title="Manage Utilities"
                v-bind:class="{selected: workflow === 'utility-admin'}">Utility</li>
                <li
                class="menu-item"
                v-on:click="showTownAdminWorkflow"
                title="Manage Towns"
                v-bind:class="{selected: workflow === 'town-admin'}">Town</li>
                <li
                class="menu-item"
                v-on:click="showCountyAdminWorkflow"
                v-bind:class="{selected: workflow === 'county-admin'}">County</li>
                <li
                class="menu-item"
                v-on:click="showUtilityTypeAdminWorkflow"
                v-bind:class="{selected: workflow === 'utility-type-admin'}">Utility Type</li>
              </ul>
            </div>
            <div class="content">
              <utility-admin v-if="workflow === 'utility-admin'" class="utility-admin-container"></utility-admin>
              <town-admin v-if="workflow === 'town-admin'" class="town-admin-container"></town-admin>
              <county-admin v-if="workflow === 'county-admin'" class="county-admin-container"></county-admin>
              <utility-type-admin v-if="workflow === 'utility-type-admin'" class="utility-type-admin-container"></utility-type-admin>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import vueMqMixin from "../../../shared/mixins/VueMqMixin";
import UtilityAdmin from './utility-admin/UtilityAdmin';
import TownAdmin from './town-admin/TownAdmin';
import CountyAdmin from './county-admin/CountyAdmin';
import UtilityTypeAdmin from './utility-type-admin/UtilityTypeAdmin';
import Authentication from "@/services/authentication";

export default {
  name: 'AdminModal',
  mixins: [vueMqMixin],
  props: {
    user: Object,
    hideModal: Function
  },
  components: {
    UtilityAdmin,
    TownAdmin,
    CountyAdmin,
    UtilityTypeAdmin
  },
  data() {
    return {
      workflow: 'utility-admin'
    }
  },
  async created() {
    this.myclass = this.isMobile() || this.isTablet() ? ['vt-outages-modal admin isMobileOrTablet'] : ['vt-outages-modal admin'];
    if (!Authentication.userIsAdmin(this.user)){return; }
    Vue.nextTick(() => this.$bvModal.show('admin-modal'));
  },
  methods: {
      cancel() {
        this.hideModal();
      },
      showDefaultWorkflow() {
        this.workflow = 'menu-item-1';
      },
      showUtilityAdminWorkflow() {
        this.workflow = 'utility-admin';
      },
      showTownAdminWorkflow() {
        this.workflow = 'town-admin';
      },
      showCountyAdminWorkflow() {
        this.workflow = 'county-admin';
      },
      showUtilityTypeAdminWorkflow() {
        this.workflow = 'utility-type-admin';
      }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/partials/_variables.scss";

.modal-body-container{
  .modal-body{
    .menu{
      .menu-items{
        padding: 0;
        margin: 0;
        list-style: none;
        display: flex;
        justify-content: start;

        .menu-item{
            list-style-type: none;
            width: 15%;
            height: 50px;
            margin: 0 20px 0 0;
            padding: 5px;
            font-weight: 500;
            line-height: 50px;
            color: #fff;
            background-color: $navy;
            text-align: center;

          &:last-child{
            margin-right: 0;
          }

          &:hover{
            cursor: pointer;
            color: #fff;
            background-color: $tealDark;
          }

          &.selected{
            color: $black;
            background-color: $lightGrey;
          }
        }
      }
    }

    .content{
      padding:  20px 50px 50px 50px;
      background-color: $lightGrey;
    }
  }
}
</style>
